export default {"src":"/_next/static/media/isp.c5b3088d.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};